import {useEffect,useState} from 'react';
import {useAuth} from '../authContext';
import {photoAccessScope} from './sessionStore';
import {photoTags,type PhotoTagState} from './tags';
import type {PhotoContext} from './contracts';

/** Selected labels remain authorized even when the filter editor is closed. */
export function usePhotoTagSuggestions(context:PhotoContext|null,selected:string[]){
 const {user,privileges}=useAuth();
 const scope=photoAccessScope(user,privileges)+JSON.stringify(context);
 const [searchState,setSearch]=useState({scope,value:''}),[revision,setRevision]=useState(0);
 const search=searchState.scope===scope?searchState.value:'';
 const key=scope+JSON.stringify(selected)+JSON.stringify(search);
 const [state,setState]=useState<{key:string;data?:PhotoTagState;error?:string}>();
 useEffect(()=>{
  if(!context)return;
  const abort=new AbortController(),timer=setTimeout(()=>void photoTags(context,[],search,abort.signal,selected)
   .then(data=>{if(!abort.signal.aborted)setState({key,data});})
   .catch(error=>{if(!abort.signal.aborted)setState({key,error:error.message});}),search?180:0);
  return()=>{clearTimeout(timer);abort.abort();};
 },[key,revision]);
 const current=context&&state?.key===key?state:undefined;
 return {search,setSearch:(value:string)=>setSearch({scope,value}),data:current?.data,error:current?.error,
  loading:!!context&&!current,retry:()=>setRevision(value=>value+1)};
}
